import Helper from 'src/support/Helper';
import _, { isNumber, isObject } from 'underscore';
import resMaker from './responseMaker'
import System from 'src/helper/system';

class ResponseMaker {
    data = [];
    data_to_send = {
        articleContentList: {
            searchFacets: [],
            list: [],
            count: 0
        }
    };

    constructor(data) {
        this.data = data;
    }

    process = async () => {
        let value = [];

        // Prepare Article List
        if (this.data.data.articleContentList !== undefined &&
            this.data.data.articleContentList !== null) {
            if (this.data.data.articleContentList.recordSetTotal !== undefined &&
                this.data.data.articleContentList.recordSetTotal !== null &&
                Number(this.data.data.articleContentList.recordSetTotal) > 0) {
                this.data_to_send.articleContentList.count = this.data.data.articleContentList.recordSetTotal;
            }

            if (this.data.data.articleContentList.webContentView !== undefined &&
                this.data.data.articleContentList.webContentView !== null &&
                Array.isArray(this.data.data.articleContentList.webContentView) &&
                this.data.data.articleContentList.webContentView.length > 0) {
                this.data.data.articleContentList.webContentView.map((v, i) => {
                    let here_v = {}
                    if (v['name'] !== undefined) {
                        here_v.name = v['name']
                    }

                    if (v['url'] !== undefined) { // url update
                        // here_v.url = v['url'].includes('onesite-uat5.avnet.com') ? v['url'].replace(/^.*\/\/[^\/]+/, '') : v['url']
                        here_v.url = v['url'] ? System.getRedirectionURL(v['url'].replace(/^.*\/\/[^\/]+/, ''))  : v['url']
                    }
                    if (v['shortDescription'] !== undefined) {
                        here_v.shortDesc = v['shortDescription']
                    }
                    if (v['longDescription'] !== undefined) {
                        here_v.longDesc = v['longDescription']
                    }

                    if (v['avn_page_type'] !== undefined) {
                        here_v.pageType = new resMaker().getPageType(v['avn_page_type'])
                    }

                    if (v['avn_date'] !== undefined) {
                        here_v.date = Helper.dateFormatFromString(v['avn_date'], true)
                    }

                    if (v['avn_image'] !== undefined) {
                        here_v.image = v['avn_image'];
                    }

                    value[i] = here_v;

                });
                this.data_to_send.articleContentList.list = value
            }

            // Prepare Search Facets
            if (this.data.data.articleContentList.FacetView !== undefined &&
                this.data.data.articleContentList.FacetView !== null &&
                this.data.data.articleContentList.FacetView.avn_filters_ntk_cs !== undefined &&
                this.data.data.articleContentList.FacetView.avn_filters_ntk_cs !== null &&
                Array.isArray(this.data.data.articleContentList.FacetView.avn_filters_ntk_cs) &&
                this.data.data.articleContentList.FacetView.avn_filters_ntk_cs.length > 0) {
                try {
                    let facetObj = {};
                    this.data.data.articleContentList.FacetView.avn_filters_ntk_cs.map((v, i) => {
                        if (v['name'] !== undefined) {
                            if (v['name'].includes('-') && v['name'].split('-').length > 0) {
                                let key = v['name'].split('-')[0].trim().replace(/\s/g, "");
                                if (key !== undefined && key !== null && key !== '') {
                                    // Prepare Array and push data if  key is unique
                                    if (facetObj[key] === undefined) {
                                        facetObj[key] = [];
                                    }
                                    facetObj[key].push({ name: v['name'].split('-')[1], count: v.count, filterName: ('avn_filters_ntk_cs:' + v['name']) })
                                }
                            }
                        }
                    });
                    if (Object.keys(facetObj).length > 0) {
                        this.data_to_send.articleContentList.searchFacets = facetObj;
                    }
                }
                catch (err) {
                    this.data_to_send.articleContentList.searchFacets = {}; // in case of error 
                }
            }
        }
        return this;
    };

    run = () => {
        return this;
    };

    get = () => {
        return {
            data: this.data_to_send
        };
    };
}
export default ResponseMaker;